export default __webpack_public_path__ + "static/media/hero-level-3-bg.450cec50.webp";